import { SpinnerOverlay, SpinnerContainer } from './spinner.styles'

export const Spinner = () => {
    return ( // Asegúrate de usar return aquí
        <SpinnerOverlay>
            <SpinnerContainer />
        </SpinnerOverlay>
    );
};